import __request__ from "routing/request";
export function loggers() {
  return __request__("GET", "/cluster/system/loggers", null, {}, {
    "Accept": ["application/json"]
  });
}
export function messages(nodeId, limit = 1e3) {
  return __request__("GET", `/cluster/system/loggers/messages/recent/${nodeId}`, null, { "limit": limit }, {
    "Accept": ["text/plain"]
  });
}
export function subsystems() {
  return __request__("GET", "/cluster/system/loggers/subsystems", null, {}, {
    "Accept": ["application/json"]
  });
}
export function setClusterSingleLoggerLevel(loggerName, level) {
  return __request__("PUT", `/cluster/system/loggers/${loggerName}/level/${level}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function setSubsystemLoggerLevel(nodeId, subsystem, level) {
  return __request__("PUT", `/cluster/system/loggers/${nodeId}/subsystems/${subsystem}/level/${level}`, null, {}, {
    "Accept": []
  });
}
